import { useSuspense } from "@api";
import type { TCommunicationTemplate } from "@bbj-types/communication";
import type { FeatureTemplate } from "@bbj-types/communication/enum";
import { useCallback } from "react";
import { axiosCommunication, axiosCommunicationInstance } from "./axios";

export type TGetCommunicationTemplates = Pick<
  TCommunicationTemplate,
  "_id" | "content" | "name" | "subject" | "type" | "organisation"
>[];

export const useGetCommunicationTemplates = () => {
  const [state, execute, cancel] = axiosCommunication<TGetCommunicationTemplates, void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (template: FeatureTemplate) => {
      return execute({
        url: "/templates",
        params: {
          feature: template,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetCommunicationTemplatesSuspense = (template: FeatureTemplate) => {
  return useSuspense(
    () =>
      axiosCommunicationInstance.get<TGetCommunicationTemplates>("/templates", {
        withCredentials: true,
        params: {
          feature: template,
        },
      }),
    []
  );
};
